import React, { Component } from 'react';
import ReactSlider from 'react-slider'
import './horizontalbuttonslider.css'

class HorizontalButtonSlider extends Component {

    render(){
        const {onAfterChange, buttonText} = this.props
        return(
            <ReactSlider
                className="horizontal-slider"
                thumbClassName="round-thumb"
                trackClassName="round-track"
                onAfterChange={value => onAfterChange(value)}
                renderThumb={(props, state) => <div {...props}>
                    {buttonText? buttonText : "Slide"} <i class="fa fa-arrow-right" ></i>
                </div>}
            />
        )
    }

} export default HorizontalButtonSlider


// WEBPACK FOOTER //
// ./src/components/HorizontalButtonSlider/index.jsx